import html2canvas from "html2canvas";

// Список папок для автоматической обработки
const folders = [
  { name: 'elements', context: require.context('../elements', false, /\.js$/) },
  { name: 'managers', context: require.context('../managers', false, /\.js$/) },
  { name: 'observers', context: require.context('../observers', false, /\.js$/) },
  { name: 'utils', context: require.context('../utils', false, /\.js$/) }
];

// Функция для обработки экспорта модулей
const processFolderExports = (requireModule) => {
  requireModule.keys().forEach((file) => {
    const moduleExports = requireModule(file);
    Object.entries(moduleExports).forEach(([exportName, exportValue]) => {
      if (!window[exportName]) {
        window[exportName] = exportValue;
      } else {
        console.warn(`Ключ '${exportName}' уже существует в объекте window. Пропускаем.`);
      }
    });
  });
};

// Обрабатываем все указанные папки
folders.forEach(({ context }) => {
  processFolderExports(context);
});

window.tabData = {
  archiveMode: {
    label: function () {
      return this.archiveMode ? 'Выбрать дату' : 'Архив';
    },
    isActive: function () {
      return this.archiveMode;
    },
    onClick: function (e) {
      const modal = new ModalManager({
        url: '/modal/rangeDateModal' //!!!нужно доработать
      });
      modal.open().then((response) => {
        this.setAdditionalData({
          data: Object.assign(response, {
            archive: true
          })
        });
        this.archiveMode = true;
        const startDate = formatDateToRF(this.additionalData._startDate);
        const endDate = formatDateToRF(this.additionalData._endDate);

        this.headTitle.innerHTML = `Архив ${startDate} — ${endDate}`;
        this._updateButtonsUI();
      });
    }
  },
  disableArchiveMode: {
    label: 'Отключить архив',
    isVisible: function () {
      return this.archiveMode;
    },
    onClick: function (e) {
      this.setAdditionalData({
        data: {}
      });
      this.archiveMode = false;

      this.headTitle.innerHTML = this.tabTitle;
      this._updateButtonsUI();
    }
  }
};

window.html2canvas = html2canvas; //!!! удалить при переходе на электрон и реализовать эту механику через него